import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";

interface Prpps {
    ognzCd: string;
    acntgYear: string;
    searchAtrzSttsCd: string;
    setOvrlMbsdsDpstDocId: Function;
    callTime: Date;
}

const BgtOvrlDpstMngList = ({ognzCd, acntgYear, searchAtrzSttsCd, setOvrlMbsdsDpstDocId, callTime}: Prpps) => {
    const [dataArr, setDataArr] = React.useState<any[]>([]); // 목록(list)
    const [listSum, setListSum] = React.useState<any>({}); // 합계(목록 합계)

    // GridTable 컬럼
    const fldInfs: fldInfsProps[] = [
        { type: "date" , fldNm: "dpstDt"       , width: 100, headAlign: "center", dataAlign: "center", label: "수입일자" },
        { type: "text" , fldNm: "bgtSbjct3stNm", width: 100, headAlign: "center", dataAlign: "center", label: "목"       },
        { type: "text" , fldNm: "abstrCn"      , width: 160, headAlign: "center", dataAlign: "left"  , label: "적요"     },
        { type: "comma", fldNm: "dpstAmt"      , width: 100, headAlign: "center", dataAlign: "right" , label: "금액"     },
        { type: "el"   , fldNm: "atrzSttsNm"   , width:  80, headAlign: "center", dataAlign: "center", label: "진행상태",
            el: (item: any) => {
                return (
                    <span className={"ls06 " + (item.atrzSttsCd === "02" ? "fc007bff" : "")}>{item.atrzSttsNm}</span> // 작성완료 Text 색상 변경
                )
            }
        },
        { type: "text", fldNm: "crtDt"             , width: 130, headAlign: "center", dataAlign: "center", label: "작성일시" },
        { type: "text", fldNm: "dpstRsdocNo"       , width: 130, headAlign: "center", dataAlign: "center", label: "문서번호" },
    ];

    // 목록 조회
    React.useEffect(() => {
        if (Util.isEmpty(ognzCd) || Util.isEmpty(acntgYear)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
        url: "system/bgt/ovrl/dpst/select-ovrl-dpst-list.do",
        methodType: "post",
        paramType: "json",
        paramData: {
            orgCd: ognzCd,
            acntgYear: acntgYear,
            searchAtrzSttsCd: searchAtrzSttsCd,
        },
        onSuccessFn: (res: any) => {
            setDataArr(res.result.list);
            setListSum(res.result.listSum.sumDpstAmt);
            AppContext.hideSpinner();
        },
        });
    }, [callTime, ognzCd, acntgYear, searchAtrzSttsCd]);


    return (
        <div className="bd1d9d9d9 bdrd6 bgcWhite">
            <div className="p5 pl15 pr15 pb15">
                <div className="dpFlx aiC jcSb mb10 h44">
                    <div className="fm-b fs16 fc007bff ls1 fw700">수입결의서 목록</div>
                </div>

                <div className="w100p ofxA ofyH bdt1 bdcEBEBEB pt6">
                    <div className="mw900">
                        <GridTable
                        tableInfo={{
                            tableHeadVsb: true,
                            styleType: AdminGridStyle,
                            fldInfs: fldInfs,
                            ordFld: { name: "dpstDt", direction: "desc" },
                            dataArr: dataArr,
                            maxRowNums: [100],
                            theadTrHeight: 40,
                            tbodyTrHeight: 35,
                            paginateClass: "pt10",
                            paginateStyle: {
                            buttonOnColor: AppContext.boardThemeColor,
                            buttonWidth: 22,
                            buttonHeight: 24,
                            buttonMarginLeft: 1,
                            buttonMarginRight: 1,
                            fontSize: 13,
                            color: "#666666",
                            letterSpacing: -0.8,
                            fontFamily: "Pretendard-Regular",
                            borderRadius: 3,
                            },
                            footerVsb: false,
                            rowClickFunc: (item: any) => {
                                setOvrlMbsdsDpstDocId(item.ovrlMbsdsDpstDocId);
                            },
                        }}
                        />

                        <table className="w100p bgcDCDCDC">
                            <colgroup>
                                <col style={{ width: "100px" }} />
                                <col style={{ width: "100px" }} />
                                <col style={{ width: "160px" }} />
                                <col style={{ width: "100px" }} />
                                <col style={{ width: "90px"  }} />
                                <col style={{ width: "130px" }} />
                                <col style={{ width: "120px" }} />
                            </colgroup>
                            <tbody>
                                <tr style={{ height: "35px" }}>
                                    <td></td>
                                    <td></td>
                                    <td style={{ textAlign: "center" }}>
                                        <span className="fs15 ls06 fc2c3e50 fw500">합계</span>
                                    </td>
                                    <td>
                                        <div className="taR pt5 pr5">
                                            <span className="fs15 ls075">{Util.comma(listSum)}</span>
                                        </div>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    )    
}

export default BgtOvrlDpstMngList;